import { createScheduleComponent } from '@play-co/components';
import { duration } from '../utils/duration';
import { Match2Reward } from '../match2/rewards/match2-rewards.ruleset';

export const JANKEN_CHALLENGE_EXPIRY_MS = duration({ hours: 24 });
export const JANKEN_UNLOCK_LEVEL = 8;

export const jankenSchedule = createScheduleComponent(
  '2026-03-01',
  'Asia/Tokyo',
  { weekly: [{ day: 'Friday', time: '00:00', duration: { days: 3 } }] },
);

export const JANKEN_MAX_DAILY_REWARDS = 5;

export const jankenMoves = ['rock', 'paper', 'scissors'] as const;
export type JankenMove = (typeof jankenMoves)[number];
export const jankenOutcomes = ['win', 'lose', 'draw'] as const;
export type JankenOutcome = (typeof jankenOutcomes)[number];
export type JankenResult =
  | { sender: 'win'; receiver: 'lose' }
  | { sender: 'lose'; receiver: 'win' }
  | { sender: 'draw'; receiver: 'draw' };

/**
 * Weighted reward table for janken wins. Total weight = 100.
 *
 * | Reward                | Weight | Chance |
 * |-----------------------|--------|--------|
 * | Energy ×1             |     15 |    15% |
 * | Rocket ×1             |     15 |    15% |
 * | Bomb ×1               |     15 |    15% |
 * | Cube ×1               |     15 |    15% |
 * | Energy (10 min)       |      5 |     5% |
 * | Rocket (10 min)       |      5 |     5% |
 * | Bomb (10 min)         |      5 |     5% |
 * | Cube (10 min)         |      5 |     5% |
 * | 10 B Points           |     10 |    10% |
 * | 20 B Points           |      5 |     5% |
 * | 50 B Points           |      5 |     5% |
 */
export const jankenRewardTable: ReadonlyArray<{
  reward: Match2Reward;
  weight: number;
}> = [
  {
    reward: { type: 'energy', amount: 1 },
    weight: 15,
  },
  { reward: { type: 'powerups', subType: 'rocket', amount: 1 }, weight: 15 },
  { reward: { type: 'powerups', subType: 'bomb', amount: 1 }, weight: 15 },
  { reward: { type: 'powerups', subType: 'cube', amount: 1 }, weight: 15 },
  {
    reward: { type: 'energy', duration: duration({ minutes: 10 }) },
    weight: 5,
  },
  {
    reward: {
      type: 'powerups',
      subType: 'rocket',
      duration: duration({ minutes: 10 }),
    },
    weight: 5,
  },
  {
    reward: {
      type: 'powerups',
      subType: 'bomb',
      duration: duration({ minutes: 10 }),
    },
    weight: 5,
  },
  {
    reward: {
      type: 'powerups',
      subType: 'cube',
      duration: duration({ minutes: 10 }),
    },
    weight: 5,
  },
  { reward: { type: 'bPoints', amount: 10 }, weight: 10 },
  { reward: { type: 'bPoints', amount: 20 }, weight: 5 },
  { reward: { type: 'bPoints', amount: 50 }, weight: 5 },
];
